export default "__VITE_ASSET__249d787b__"